import { render, staticRenderFns } from "./StatsView.vue?vue&type=template&id=7ae38d5c&scoped=true"
import script from "./StatsView.vue?vue&type=script&lang=js"
export * from "./StatsView.vue?vue&type=script&lang=js"
import style0 from "./StatsView.vue?vue&type=style&index=0&id=7ae38d5c&prod&scoped=true&lang=css"
import style1 from "./StatsView.vue?vue&type=style&index=1&id=7ae38d5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae38d5c",
  null
  
)

export default component.exports